/**
 * @file 认证企搜索结果页-H5版
 * @author zhaomiaoyuan
 */

import React from 'react';
import PropTypes from 'prop-types';

import phoneSvg from '../../asset/img/userCenter/microCard/phone.svg';
import searchIcon from '../../asset/img/userCenter/microCard/search-icon.png';
import searchBtn from '../../asset/img/userCenter/microCard/input-icon-search.png';
import iconQuestion from '../../asset/img/userCenter/microCard/icon-question.png';
import iconBlueGood from '../../asset/img/userCenter/microCard/icon-blue-good-finger.png';

import './searchResult.less';

export default function SearchResult(props: any) {
    const {searchResult} = props;
    const renderSearchInput = () => {
        return (
            <div className="search-result-input-box">
                <div className="search-result-input">
                    <span>{searchResult.title}</span>
                </div>
                <div className="search-result-btn">
                    <img width={24} src={searchBtn}></img>
                </div>
            </div>
        );
    };
    const renderSearchCard = () => {
        return (
            <div className="search-card">
                <div className="search-icon">
                    <img src={searchIcon}></img>
                </div>
                <div className="search-h1">{searchResult.title}</div>
                <div className="search-info">以下号码为「企业官方号码」</div>
            </div>
        );
    };
    const renderPhoneList = () => {
        if (!searchResult.phone_list) {
            return;
        }
        return (
            <div className="phone-list">
                {searchResult.phone_list.map((item, index) => {
                    return (
                        <div className="phone-item" key={item + index}>
                            <div className="phone-info">
                                <div className="phone-title">{item?.name}</div>
                                <div className="phone-num">
                                    {item.phone + (item.extension_phone ? '转' + item.extension_phone : '')}
                                </div>
                            </div>
                            <div className="phone-icon">
                                <img src={phoneSvg} alt="tel" />
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    };

    // const renderAddress = () => {
    //     if (!searchResult.address) {
    //         return;
    //     }
    //     return (
    //         <div className="search-result-address">
    //             <div className="search-number-info">
    //                 <div className="search-number-name">地址</div>
    //                 <div className="search-poi-address">{searchResult.address}</div>
    //             </div>
    //         </div>
    //     );
    // };

    const renderWebsite = () => {
        if (!searchResult.url) {
            return null;
        }
        return (
            <div className="search-result-website">
                <div className="search-number-info">
                    <div className="search-number-name website">企业官网</div>
                </div>
            </div>
        );
    };
    const renderAppealBtn = () => {
        return (
            <div className="search-result-btn">
                <div className="btn-link">
                    <img className="icon" src={iconQuestion}></img>
                    <span>号码报错</span>
                </div>
                <div className="btn-wrapper">
                    <div className="btn-wrapper-con">
                        <img className="icon" src={iconBlueGood}></img>
                        <span>服务评价</span>
                    </div>
                </div>
            </div>
        );
    };
    const renderFooterBtn = () => {
        return (
            <div className="search-result-footer-btn">
                <div className="search-result-footer-btn-con">去认证我的企业号码</div>
            </div>
        );
    };

    return (
        <div className="search-result">
            {renderSearchInput()}
            <div className="search-result-con">
                {renderSearchCard()}
                {renderPhoneList()}
                {/* {renderAddress()} */}
                {renderWebsite()}
                {renderAppealBtn()}
            </div>
            {renderFooterBtn()}
        </div>
    );
}

SearchResult.propTypes = {
    history: PropTypes.any,
    company_adverts: PropTypes.any,
    searchResult: PropTypes.object
};
